const TONES: Record<string, { bg: string; color: string; border: string }> = {
  pink: { bg: '#fdf2f8', color: '#d6006e', border: '#fce7f3' },
  green: { bg: '#ecfdf5', color: '#047857', border: '#a7f3d0' },
  amber: { bg: '#fffbeb', color: '#b45309', border: '#fde68a' },
  slate: { bg: '#f8fafc', color: '#475569', border: '#e2e8f0' },
  rose: { bg: '#fff1f2', color: '#be123c', border: '#fecdd3' },
};

type StatusPillProps = {
  label: string;
  tone?: keyof typeof TONES;
};

export default function StatusPill({ label, tone = 'pink' }: StatusPillProps) {
  const t = TONES[tone];
  return (
    <span
      className="inline-flex rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider"
      style={{ background: t.bg, color: t.color, border: `1px solid ${t.border}` }}
    >
      {label}
    </span>
  );
}
